export default __webpack_public_path__ + "static/twitter-image-7492fdf11573674f6867488f1bb676c1.png";